import React from 'react';
import ReactDOM from 'react-dom/client';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import App from '@app/index';

import './assets/css/index.css';

import { BrowserRouter } from 'react-router-dom';

import { ReferralProvider } from '@contexts/referral-context';
import { UserAuthProvider } from '@contexts/user-context';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      staleTime: 5 * 60 * 1000,
    },
  },
});

ReactDOM.createRoot(
  (document.getElementById('root') as HTMLElement) ||
    document.createElement('div')
).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <UserAuthProvider>
          <ReferralProvider>
            <App />
          </ReferralProvider>
        </UserAuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
